import * as yup from 'yup'

export const categorySchema = yup.object({
    name: yup
        .string()
        .required('Category Name is required')
        .min(3, 'Category Name must be at least 3 characters')
        .max(25, 'Category Name Only 25 characters allowed'),

    shortDescription: yup
        .string()
        .required('Short Description is required')
        .min(10, 'Short Description must be at least 10 characters')
        .max(75, 'Short Description Only 75 characters allowed'),

    longDescription: yup
        .string()
        .nullable(),

    categoryPriority: yup
        .number()
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value
        )
        .typeError('Priority must be a number')
        .required('Priority is required')
        .min(1, 'Priority must be at least 1'),
    labels: yup
        .array()
        .of(yup.string())
        .min(1, 'At least one label is required')
        .required(),

    templateId: yup
        .string()
        .required('Template is required'),
    icon: yup
        .string()
        .required('Icon is required'),

    chipImage: yup
        .mixed()
        .required('Chip image is required')
        .test(
            'file-or-string',
            'Icon must be a file or a valid string',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),


})
